export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  products: "nav-products",
  services: "nav-services",
  process: "nav-process",
  about: "nav-about",
  testimonials: "nav-testimonials",
  resources: "nav-resources",
  blog: "nav-blog",
  caseStudies: "nav-case-studies",
  dealStructures: "nav-deal-structures",
  faq: "nav-faq",
  contact: "nav-contact",
  applyButton: "nav-apply-button",
  mobileMenuToggle: "nav-mobile-toggle",
};

export const HERO_LEAD = {
  form: "hero-lead-capture-form",
  name: "hero-lead-name",
  email: "hero-lead-email",
  phone: "hero-lead-phone",
  amount: "hero-lead-amount",
  submit: "hero-lead-submit",
};

export const APPLY = {
  form: "apply-multi-step-form",
  next: "apply-next-button",
  back: "apply-back-button",
  submit: "apply-submit-button",
  stepIndicator: "apply-step-indicator",
};

export const ADMIN = {
  loginPassword: "admin-login-password",
  loginButton: "admin-login-button",
  submissionsTable: "admin-submissions-table",
  submissionRow: "admin-submission-row",
  exportNewsletter: "admin-export-newsletter",
};
